import { render, staticRenderFns } from "./AdminAccnt.vue?vue&type=template&id=5cb5e13e&scoped=true&"
import script from "./AdminAccnt.vue?vue&type=script&lang=js&"
export * from "./AdminAccnt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb5e13e",
  null
  
)

export default component.exports